<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">{{ node.id ? $t('node.add.editTitle') : $t('node.add.newTitle') }}</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12 pb-2">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label><span class="required">*</span> {{ $t('node.form.nameLabel') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="node.name"
                    placeholder=""
                  />
                </div>
                <div class="form-group col-md-6">
                  <label><span class="required">*</span> {{ $t('node.form.typeLabel') }}</label>
                  <v-select
                    :options="nodeTypes"
                    :reduce="(t) => t.id"
                    label="name"
                    v-model="node.type_id"
                    class="vselect"
                    :placeholder="$t('node.form.typePlaceholder')"
                    @input="onTypeChange"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label
                    >{{ $t('node.form.parentLabel') }}
                    <small class="text-muted">{{ $t('node.add.parentHint') }}</small
                    >:</label
                  >
                  <v-select
                    :options="parentNodes"
                    :reduce="(n) => n.id"
                    label="name"
                    v-model="node.parent_id"
                    class="vselect"
                    :placeholder="$t('node.form.parentPlaceholder')"
                    :clearable="true"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label
                    >{{ $t('node.form.tenantIdLabel') }}
                    <small class="text-muted">{{ $t('node.form.optionalHint') }}</small>:</label
                  >
                  <input
                    type="number"
                    class="form-control"
                    v-model="node.tenant_id"
                    placeholder=""
                  />
                </div>
              </div>
              <!-- Campos dinâmicos do tipo selecionado -->
              <div v-if="fieldSchema.length" class="mt-3">
                <hr />
                <p class="font-weight-bold mb-2">
                  {{ $t('node.form.typeInfoTitle') }} <em>{{ selectedTypeName }}</em>
                </p>
                <div class="form-row">
                  <div
                    v-for="field in fieldSchema"
                    :key="field.key"
                    :class="['form-group', field.col || 'col-md-6']"
                  >
                    <label>
                      <span v-if="field.required" class="required">*</span>
                      {{ field.label }}:
                    </label>

                    <input
                      v-if="field.type === 'text'"
                      type="text"
                      class="form-control"
                      v-model="node.metadata[field.key]"
                      placeholder=""
                    />
                    <input
                      v-else-if="field.type === 'number'"
                      type="number"
                      class="form-control"
                      v-model="node.metadata[field.key]"
                      placeholder=""
                    />
                    <textarea
                      v-else-if="field.type === 'textarea'"
                      class="form-control"
                      rows="3"
                      v-model="node.metadata[field.key]"
                    />
                    <select
                      v-else-if="field.type === 'select'"
                      class="form-control"
                      v-model="node.metadata[field.key]"
                    >
                      <option value="">{{ $t('node.form.selectOption') }}</option>
                      <option
                        v-for="opt in field.options"
                        :key="opt"
                        :value="opt"
                      >
                        {{ opt }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-md-12">
                  <b-button v-if="$hasAbility('node.admin')" variant="primary" @click="save">{{ $t('common.save') }}</b-button>
                  <b-button
                    variant="outline-secondary"
                    class="ml-1"
                    @click="$router.push('/nodes')"
                  >
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";
import vSelect from "vue-select";

export default {
  components: { BButton, vSelect },
  data() {
    return {
      node: {
        id: null,
        name: "",
        type_id: null,
        parent_id: null,
        tenant_id: null,
        metadata: {},
      },
      nodeTypes: [],
      parentNodes: [],
      fieldSchema: [],
    };
  },
  computed: {
    selectedTypeName() {
      const t = this.nodeTypes.find((t) => t.id === this.node.type_id);
      return t ? t.name : "";
    },
  },
  methods: {
    onTypeChange(typeId) {
      const type = this.nodeTypes.find((t) => t.id === typeId);
      this.fieldSchema = type && type.field_schema ? type.field_schema : [];
      // Preserva valores existentes, inicializa chaves novas
      const meta = this.node.metadata || {};
      this.fieldSchema.forEach((f) => {
        if (!(f.key in meta)) meta[f.key] = "";
      });
      this.node.metadata = meta;
    },

    save() {
      const self = this;
      let api = self.$store.state.api + "nodes";

      if (self.node.id) {
        api += "/" + self.node.id;
        self.node._method = "PUT";
      }

      self.$loading(true);
      self.$http
        .post(api, self.node)
        .then(() => {
          self.$message(
            self.$t("node.messages.successTitle"),
            self.$t("node.add.messages.saved"),
            "success",
          );
          self.$loading(false);
          self.$router.push("/nodes");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },

    getNode(id) {
      const self = this;
      self.$loading(true);
      self.$http
        .get(
          self.$store.state.api + "nodes/" + id + "?with[]=type&with[]=parent",
        )
        .then((response) => {
          const data = response.data.data[0];
          self.node = data;
          self.node.metadata = data.metadata || {};
          // Carrega schema do tipo depois que nodeTypes já estão disponíveis
          if (data.type_id) self.onTypeChange(data.type_id);
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },

    getNodeTypes() {
      axios
        .get(this.$store.state.api + "node_types?paginated=false")
        .then((response) => {
          this.nodeTypes = response.data.data;
          // Se já tem tipo selecionado (edição), carrega schema
          if (this.node.type_id) this.onTypeChange(this.node.type_id);
        });
    },

    getParentNodes() {
      axios
        .get(this.$store.state.api + "nodes?paginated=false")
        .then((response) => {
          const all = response.data.data;
          this.parentNodes = all.filter((n) => n.id !== this.node.id);
        });
    },
  },
  mounted() {
    const id = this.$route.params.id;
    this.getNodeTypes();
    this.getParentNodes();
    if (id) this.getNode(id);
  },
};
</script>

<style scoped>
.required {
  color: red;
}
</style>
